/* eslint-disable sort-keys-fix/sort-keys-fix */
import type { DefaultGenerics, Route } from "@tanstack/react-location"
import { lazy } from "react"

// Misc
const App = lazy(() => import("./App"))

// Main
const Main = lazy(() => import("./App/Main"))
const Pool = lazy(() => import("./App/Main/Pool"))
const Dashboard = lazy(() => import("./App/Main/Pool/dashboard/Dashboard"))
const EventLog = lazy(() => import("./App/Main/Pool/eventlog/EventLog"))

// Input
const InputList = lazy(() => import("./App/Main/Pool/input/InputList"))
const InputOverviewTab = lazy(() => import("./App/Main/Pool/input/InputView/OverviewTab"))
const InputView = lazy(() => import("./App/Main/Pool/input/InputView"))
const InputConfigurationTab = lazy(() => import("./App/Main/Pool/input/InputView/ConfigurationTab"))
const LinkTabs = lazy(() => import("./App/Main/Pool/input/InputView/LinksTab/index"))
const StreamSwitchTab = lazy(() => import("./App/Main/Pool/input/InputView/StreamSwitchTab"))
const InputStreamEdit = lazy(
  () => import("./App/Main/Pool/input/InputView/ConfigurationTab/InputStreamEdit")
)

// Output
const OutputView = lazy(() => import("./App/Main/Pool/output/OutputView"))
const OutputList = lazy(() => import("./App/Main/Pool/output/OutputList/index"))
const OutputOverviewTab = lazy(() => import("./App/Main/Pool/output/OutputView/OverviewTab"))
const OutputLinkTab = lazy(() => import("./App/Main/Pool/output/OutputView/LinkedInputTab"))
const OutputConfigurationTab = lazy(
  () => import("./App/Main/Pool/output/OutputView/ConfigurationTab")
)
const TranscodingTab = lazy(() => import("./App/Main/Pool/output/OutputView/TranscodingTab"))

// Others
const SchedulerEventList = lazy(() => import("./App/Main/Pool/scheduler/index"))
const SchedulerEventDetails = lazy(() => import("./App/Main/Pool/scheduler/SchedulerEventDetails"))

const Settings = lazy(() => import("./App/Main/Pool/settings/Settings"))
const AddPoolApiKey = lazy(() => import("./App/Main/Pool/settings/Settings/apiKeys/AddApiKey"))
const EditPoolApiKey = lazy(() => import("./App/Main/Pool/settings/Settings/apiKeys/EditApiKey"))
const TranscodingPresetList = lazy(() => import("./App/Main/Pool/presets/TranscodingPresetList"))
const TranscodingPresetDetail = lazy(
  () => import("./App/Main/Pool/presets/TranscodingPresetDetail")
)

// New Pool
const NewPool = lazy(() => import("./App/NewPool"))

export const linkRoutes: Route<DefaultGenerics> = {
  path: "link",
  element: <App />,
  children: [
    {
      path: "pools",
      element: <Main />,
      children: [
        {
          path: ":poolUuid",
          element: <Pool />,
          children: [
            { path: "/", element: <Dashboard /> },
            {
              path: "outputs/:outputUuid",
              element: <OutputView />,
              children: [
                {
                  path: "overview",
                  element: <OutputOverviewTab />
                },
                {
                  path: "transcoding",
                  element: <TranscodingTab />
                },
                {
                  path: "link",
                  element: <OutputLinkTab />
                },
                {
                  path: "configuration",
                  element: <OutputConfigurationTab />
                }
              ]
            },
            { path: "outputs", element: <OutputList /> },
            {
              path: "scheduler",
              children: [
                { path: "/", element: <SchedulerEventList /> },
                {
                  path: "edit_event/:scheduledEventUuid",
                  element: <SchedulerEventDetails />
                }
              ]
            },
            { path: "settings/apikeys/new", element: <AddPoolApiKey /> },
            { path: "settings/apikeys/:apiKeyUuid", element: <EditPoolApiKey /> },
            { path: "settings", element: <Settings /> },
            { path: "eventlog", element: <EventLog /> },
            {
              path: "inputs/:inputUuid",
              element: <InputView />,
              children: [
                {
                  path: "links",
                  element: <LinkTabs />
                },
                {
                  path: "overview",
                  element: <InputOverviewTab />
                },
                {
                  path: "switch",
                  element: <StreamSwitchTab />
                },
                {
                  path: "configuration",
                  element: <InputConfigurationTab />,
                  children: [
                    {
                      path: ":streamUuid",
                      element: <InputStreamEdit />
                    }
                  ]
                }
              ]
            },
            { path: "inputs", element: <InputList /> },
            {
              path: "presets",
              children: [
                { path: "/", element: <TranscodingPresetList /> },
                {
                  path: ":transcodingPresetUuid",
                  element: <TranscodingPresetDetail />
                }
              ]
            }
          ]
        }
      ]
    },
    {
      path: "new_pool",
      element: <NewPool />
    }
  ]
}
